import { Button } from "@kyan/ui";

import { ConnectWalletWrapper } from "#/components/ConnectWalletWrapper/ConnectWalletWrapper";
import { confirmTrade } from "#/utils/modals/confirmTrade";

import { Hedge } from "../../../OptionsTab/components/SelectedOption/components/Hedge/Hedge";
import { PortfolioImpactAndGreeks } from "../../../OptionsTab/components/SelectedOption/components/PortfolioImpactAndGreeks/PortfolioImpactAndGreeks";
import { TradeConfirmationOptionInstrument } from "../TradeConfirmationOptionInstrument/TradeConfirmationOptionInstrument";
import { TradeConfirmModalButton } from "../TradeConfirmModalButton/TradeConfirmModalButton";
import { useHedgeTradeButtonController } from "./HedgeTradeButton.controller";

export interface HedgeTradeButtonProps {
  isTradeConfirmation?: boolean;
  onSuccess?: () => void;
}

export const HedgeTradeButton: React.FC<HedgeTradeButtonProps> = ({
  isTradeConfirmation = false,
  onSuccess,
}) => {
  const {
    isLoading,
    isDisabled,
    buttonLabel,
    showTradeConfirmation,
    handleSubmit,
  } = useHedgeTradeButtonController(onSuccess);

  // if we move this logic into the controller, since we are using MarketTradeButton we will face circular dependency issues
  const handleClick = () => {
    if (showTradeConfirmation && !isTradeConfirmation) {
      confirmTrade({
        header: "Market-Limit Order",
        children: (
          <div className="grid gap-4">
            <TradeConfirmationOptionInstrument />
            <Hedge />
            <PortfolioImpactAndGreeks isTradeConfirmation />
          </div>
        ),

        tradeButton: ({ handleClose }) => (
          <TradeConfirmModalButton
            isTradeConfirmation
            onSuccess={handleClose}
          />
        ),
      });
      return;
    }

    handleSubmit();
  };

  return (
    <ConnectWalletWrapper>
      <Button
        size="lg"
        disabled={isDisabled}
        isLoading={isLoading}
        className="mt-2 w-full text-[15px] shadow-none"
        onClick={handleClick}
      >
        {buttonLabel}
      </Button>
    </ConnectWalletWrapper>
  );
};
